import "./Map.scss";
const Map = () => {
  // const defaultProps = {
  //   center: {
  //     lat: 10.99835602,
  //     lng: 77.01502627,
  //   },
  //   zoom: 11,
  // };

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      Map
    </div>
  );
};
export default Map;
